import { useRef,useEffect } from 'react'
import Canvas from "../../../../../components/vectors/canvas";

const SFVectorAnswer = ({ vector, vectorSettingsData }) => {
        const canvasRef = useRef(null);
      
        useEffect(() => {
          if (canvasRef && canvasRef.current && vector && vector.length > 0 )
          {
            canvasRef.current.drawVectors({ vectors: [...vector] });
          }
        }, [canvasRef, vector]);
     
        if(vectorSettingsData && vector.length > 0){
          return (
            <Canvas
              ref={canvasRef}
              readOnly={true}
              degStepSize={5}
              magStepSize={1}
              rulerXPoint={vectorSettingsData.rulerXPoint}
              rulerYPoint={vectorSettingsData.rulerYPoint}
              rulerXLabel={vectorSettingsData.rulerXLabel}
              rulerYLabel={vectorSettingsData.rulerYLabel}
              rulerNXLabel={vectorSettingsData.rulerNXLabel}
              rulerNYLabel={vectorSettingsData.rulerNYLabel}
              height={vectorSettingsData.height}
              width={vectorSettingsData.width}
              stepSize={vectorSettingsData.stepSize}
              enableGrid={vectorSettingsData.enableGrid}
              enableBorder={vectorSettingsData.enableBorder}
              enableDarkGridLine={vectorSettingsData.enableDarkGridLine}
              enableRuler={vectorSettingsData.enableRuler}
              gridColor={vectorSettingsData.gridColor}
              stepDeg={true}
              freeBodyDiagram={vectorSettingsData.image}
              fbdWidth={vectorSettingsData.imageWidthUnit * vectorSettingsData.stepSize}
              fbdHeight={vectorSettingsData.imageHeightUnit * vectorSettingsData.stepSize}
              fbdX={vectorSettingsData.imageX}
              fbdY={vectorSettingsData.imageY}
              commonVectorSettings={vectorSettingsData}
              isAnswer={true}
              showScale={vectorSettingsData.showScale}
              scale={vectorSettingsData.scale}
            ></Canvas>
          );
        }
        else
          return null;
      };

export default SFVectorAnswer;


